module.exports = __webpack_public_path__ + "img/day3.80ee1ca0.jpeg";